import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomIcons } from '@shared/models/custom-icons';
import { DOCUMENT, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  private _pathIcons = 'assets/svg/';
  private _addedIcons: CustomIcons[] = [];

  public get addedIcons(): CustomIcons[] {
    return [...this._addedIcons];
  }
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) platformId: string,
    @Inject(DOCUMENT) document: Document
  ) {
    if (isPlatformServer(platformId)) {
      this._pathIcons = `${document.location.origin}/${this._pathIcons}`;
    }
  }

  private addIcon(iconName: CustomIcons): void {
    const isIconAdded = this._addedIcons.some(icon => icon === iconName);
    if (!isIconAdded) {
      this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(`${this._pathIcons}${iconName}.svg`));
      this._addedIcons.push(iconName);
    }
  }

  public addIconPack(icons: CustomIcons[]): void {
    icons.forEach(icon => {
      this.addIcon(icon);
    });
  }
}
